export default function(x) {
  return (1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x)));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/e0fn.js
// module id = 53
// module chunks = 0